export default {
  data() {
    return {
      NOTIFICATION_TYPES_STATE: {
        SUCCESS: 1,
        WARNING: 2,
        ERROR: 3
      },
      NOTIFICATION_TYPES: {
        SUCCESS_FULL_OPERATION: 1,
        ERROR_OPERATION: 2,
        ADD_TO_CART: 3,
        PERSONAL_DATA_SAVED: 4,
        PASSWORD_CHANGED: 5,
        REFER_LINK_CREATED: 6,
        REFER_LINK_MAIN_ACTION: 7,
        COUPON_CREATED: 8,
        COUPON_DELETED: 9,
        SENT_GROUP_TRANSFERS: 10,
        SUBSCRIBED: 11,
        SAVED_LOGO: 12,
        REQUEST_TO_CANCEL_ORDER: 13,
        FAIL_HOTELS_LOGIN: 14,
        LEAVE_FEEDBACK: 15,
        SENT_CONTACT: 16,
        SENT_PARTNERSHIP: 17,
        SENT_HOLIDAY_FORM: 18,
        SENT_WORLDTOUR_FORM: 19,
      }
    };
  }
}
